module.exports = "<p>\n  painel-controle works!\n</p>\n"